import XLSX from 'xlsx'

export function upload(rawFile, callback) {
  readerData(rawFile, callback)
}

export function uploadMultiSheet(rawFile, callback) {
  const reader = new FileReader()
  reader.onload = e => {
    const sheet = []
    const header = []
    const results = []
    const data = e.target.result
    const workbook = XLSX.read(data, { type: 'array' })
    for (let i = 0; i < workbook.SheetNames.length; i++) {
      const sheetName = workbook.SheetNames[i]
      sheet.push(sheetName)
      const worksheet = workbook.Sheets[sheetName]
      const curHeader = getHeaderRow(worksheet)
      header.push(curHeader)
      const tmp = XLSX.utils.sheet_to_json(worksheet)
      const curResults = []
      const last = []
      tmp.forEach((value, index) => {
        const tmp2 = []
        curHeader.forEach((v, i) => {
          if (value[v] !== null) {
            if (last[v] !== value[v]) {
              last[v] = value[v]
            }
            tmp2.push(value[v])
          } else {
            tmp2.push(last[v])
          }
        })
        curResults.push(tmp2)
      })
      results.push(curResults)
    }
    callback({ sheet, header, results })
  }
  reader.readAsArrayBuffer(rawFile)
}

export function downloadExcel(filename, header, data) {
  import('@/vendor/Export2Excel').then(excel => {
    excel.export_json_to_excel({
      header: header,
      data,
      filename: filename,
      autoWidth: true,
      bookType: 'xlsx'
    })
  })
}

export function downloadExcelMultiSheet(filename, sheet, header, data) {
  import('@/vendor/Export2Excel').then(excel => {
    excel.export_json_to_excel_MultiSheet({
      multiSheet: sheet,
      multiHeader: header,
      multiData: data,
      filename: filename,
      autoWidth: true,
      bookType: 'xlsx'
    })
  })
}

function readerData(rawFile, callback) {
  const reader = new FileReader()
  reader.onload = e => {
    const data = e.target.result
    const workbook = XLSX.read(data, { type: 'array' })
    const firstSheetName = workbook.SheetNames[0]
    const worksheet = workbook.Sheets[firstSheetName]
    const header = getHeaderRow(worksheet)
    const tmp = XLSX.utils.sheet_to_json(worksheet)
    const results = []
    const last = []
    tmp.forEach((value, index) => {
      const tmp2 = []
      header.forEach((v, i) => {
        if (value[v] !== null) {
          if (last[v] !== value[v]) {
            last[v] = value[v]
          }
          tmp2.push(value[v])
        } else {
          tmp2.push(last[v])
        }
      })
      results.push(tmp2)
    })
    callback({ header, results })
  }
  reader.readAsArrayBuffer(rawFile)
}

function getHeaderRow(sheet) {
  if (sheet['!ref'] === undefined) {
    return []
  }
  const headers = []
  const range = XLSX.utils.decode_range(sheet['!ref'])
  let C
  const R = range.s.r
  /* start in the first row */
  for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
    const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
    /* find the cell in the first row */
    let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
    if (cell && cell.t) {
      hdr = XLSX.utils.format_cell(cell)
      headers.push(hdr)
    }
  }
  const out = []
  for (let i = 0; i < headers.length; i++) {
    if (headers[i] !== null && headers[i] !== '' && headers[i] !== undefined) {
      out.push(headers[i])
    }
  }
  return out
}
